module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.6@readable-stream/writable-browser.js
// module id = oYsp
// module chunks = 0